// The hotel's routes and the two module menus — board 27 §أ (every artboard's
// column, in board order) and HANDOFF-erp-web §17; base `/erp/hotel` is the
// app's `/hotel` (every path here is absolute, as HANDOFF §3 maps them).
//
// Gates: flags per the Shared contracts (channels · restaurant · properties);
// roles per the board's permission matrix (properties--consolidated: «خطط
// الأسعار والقنوات» = المالك + مدير العقار, «الحجز والوصول والفوليو» = everyone,
// «التبديل بين العقارات» = المالك). The restaurant POS posts to the folio from
// the desk (rule 7), so it is everyone's. Sector words («التدبير المنزلي»,
// «إغلاق اليوم») come through terminology; the rest are the board's labels.

import type { Gate, MenuItem } from '@/app/module-types';

/** The rail labels (board 27) — the page heads' eyebrow «الغرف › …». */
export const ROOMS_LABEL = 'الغرف';
export const RESERVATIONS_LABEL = 'الحجوزات';

export const HOTEL_PATHS = {
  tape: '/hotel/rooms/tape',
  roomsToday: '/hotel/rooms/today',
  housekeeping: '/hotel/housekeeping',
  nightAudit: '/hotel/night-audit',
  ratePlans: '/hotel/rate-plans',
  channels: '/hotel/channels',
  restaurant: '/hotel/restaurant',
  properties: '/hotel/properties',
  reservations: '/hotel/reservations',
  stays: '/hotel/stays',
  folios: '/hotel/folios',
  companies: '/hotel/companies',
} as const;

/** The list views of `/hotel/reservations?view=` (ruling H1). */
export type ReservationsView = 'arrivals' | 'departures' | 'all';

export function reservationsHref(view: ReservationsView): string {
  return `${HOTEL_PATHS.reservations}?view=${view}`;
}

export const RATE_PLANS_GATE: Gate = { minRole: 'manager' };
export const CHANNELS_GATE: Gate = { minRole: 'manager', flag: 'erp.channels' };
export const RESTAURANT_GATE: Gate = { flag: 'erp.restaurant' };
export const PROPERTIES_GATE: Gate = { minRole: 'owner', flag: 'erp.branches' };

/** The «الإعداد» eyebrow of the «الغرف» column (board 27). */
const SETUP = 'الإعداد';

export const ROOMS_MENU: MenuItem[] = [
  { key: 'tape', label: 'اللوحة الزمنية', to: HOTEL_PATHS.tape },
  { key: 'today', label: 'اليوم', to: HOTEL_PATHS.roomsToday },
  { key: 'housekeeping', label: 'التدبير المنزلي', termLabel: 'housekeeping', to: HOTEL_PATHS.housekeeping },
  { key: 'night-audit', label: 'إغلاق اليوم', termLabel: 'night_audit', to: HOTEL_PATHS.nightAudit },
  { key: 'rate-plans', label: 'خطط الأسعار', to: HOTEL_PATHS.ratePlans, section: SETUP, ...RATE_PLANS_GATE },
  { key: 'channels', label: 'قنوات الحجز', to: HOTEL_PATHS.channels, section: SETUP, ...CHANNELS_GATE },
  { key: 'restaurant', label: 'المطعم', to: HOTEL_PATHS.restaurant, section: SETUP, ...RESTAURANT_GATE },
  { key: 'properties', label: 'العقارات', to: HOTEL_PATHS.properties, section: SETUP, ...PROPERTIES_GATE },
];

/** The «الشركات» eyebrow of the «الحجوزات» column (board 27). */
const COMPANIES = 'الشركات';

export const RESERVATIONS_MENU: MenuItem[] = [
  { key: 'arrivals', label: 'الوصول اليوم', to: reservationsHref('arrivals') },
  { key: 'departures', label: 'المغادرة اليوم', to: reservationsHref('departures') },
  { key: 'all', label: 'كل الحجوزات', to: reservationsHref('all') },
  { key: 'companies', label: 'الوفود والشركات', to: HOTEL_PATHS.companies, section: COMPANIES },
];
